import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Headers from '../components/Headers'
import Footer from '../components/Footer'
import Stripe from '../components/Stripe'
import UPIPaymentQR from '../components/PaymentQr'
import nogot from '../assets/payment/nogot.png'
import codImg from '../assets/payment/cod.png'
import stripeImg from '../assets/payment/stripe.png'
import gpayImg from '../assets/payment/gpay.png'
import { base_url } from '../utils/config'

const UPI_ID = 'abbajumma48-1@okicici'

export default function Payment() {
  const navigate = useNavigate()
  const {
    state: { price, items, orderId: initialOrderId } = {}
  } = useLocation()
  const [method, setMethod] = useState('stripe')

  // helper: persist and jump to ConfirmOrder
  // const goToConfirm = id => {
  //   localStorage.setItem('orderId', id)
  //   navigate('/order/confirm', { state: { orderId: id } })
  // }

  const goToConfirm = id => {
  localStorage.setItem('orderId', id)
  // hard-redirect to *this* app’s origin
  window.location.href = `${window.location.origin}/order/confirm?orderId=${id}`
}

  // Stripe → just route on success
  const handleStripeSuccess = id => {
    console.log('[Stripe] paid for order', id)
    goToConfirm(id)
  }

  // COD → mark paid, then route
  const handleCOD = async () => {
    const id = initialOrderId || localStorage.getItem('orderId')
    try {
      const res = await fetch(`${base_url}/api/payment/request-confirm`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId: id, cod: true })
      })
      const data = await res.json()
      if (data.success) goToConfirm(id)
      else console.error('[COD] failed →', data)
    } catch (err) {
      console.error('[COD] network error →', err)
    }
  }

  // UPI → mark paid, then route
  const handleUPIConfirm = async () => {
    const id = initialOrderId || localStorage.getItem('orderId')
    try {
      const res = await fetch(`${base_url}/api/payment/confirm-upi`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId: id })
      })
      const data = await res.json()
      if (data.success) goToConfirm(id)
      else console.error('[UPI] failed →', data)
    } catch (err) {
      console.error('[UPI] network error →', err)
    }
  }

  return (
    <div>
      <Headers />

      <section className="bg-[#eeeeee]">
        <div className="container mx-auto py-16">
          <div className="flex flex-wrap md:flex-col-reverse">
            {/* ── LEFT: payment methods ── */}
            <div className="w-7/12 md:w-full">
              <div className="flex flex-wrap border-b">
                {[
                  { key: 'stripe', label: 'Stripe', img: stripeImg },
                  { key: 'nogot',  label: 'Nogot',  img: nogot   },
                  { key: 'gpay',   label: 'UPI QR', img: gpayImg },
                  { key: 'cod',    label: 'COD',    img: codImg  }
                ].map(({ key, label, img }) => (
                  <div
                    key={key}
                    onClick={() => setMethod(key)}
                    className={`w-1/4 cursor-pointer py-8 text-center ${
                      method === key ? 'bg-white' : 'bg-slate-100'
                    }`}
                  >
                    <img src={img} alt={label} className="mx-auto mb-2" />
                    <span className="text-slate-600">{label}</span>
                  </div>
                ))}
              </div>

              <div className="mt-6">
                {method === 'stripe' && (
                  <Stripe
                    orderId={initialOrderId}
                    price={price}
                    onSuccess={handleStripeSuccess}
                  />
                )}

                {method === 'nogot' && (
                  <div className="bg-white shadow-sm p-8">
                    <button
                      className="px-10 py-2 bg-orange-500 text-white rounded"
                      onClick={() => alert('Nogot flow not implemented')}
                    >
                      Pay Now
                    </button>
                  </div>
                )}

                {method === 'gpay' && (
                  <div>
                    <UPIPaymentQR
                      price={price}
                      orderId={initialOrderId}
                      upiId={UPI_ID}
                    />
                    <div className="mt-4 text-center">
                      <button
                        onClick={handleUPIConfirm}
                        className="px-8 py-2 bg-green-600 text-white rounded"
                      >
                        I have paid
                      </button>
                    </div>
                  </div>
                )}

                {method === 'cod' && (
                  <div className="bg-white shadow-sm p-8">
                    <button
                      onClick={handleCOD}
                      className="px-10 py-2 bg-green-600 text-white rounded"
                    >
                      Place Order (COD)
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* ── RIGHT: summary ── */}
            <div className="w-5/12 md:w-full">
              <div className="bg-white shadow p-5 text-slate-600">
                <h2>Order Summary</h2>
                <div className="flex justify-between">
                  <span>{items} items &amp; shipping</span>
                  <span>₹{price}</span>
                </div>
                <div className="flex justify-between font-semibold mt-2">
                  <span>Total Amount</span>
                  <span className="text-lg text-orange-500">₹{price}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}
